import { call } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

export function* setSourceShuffleMode({ payload: { enabled, sourceId } }) {
  yield call(putAndWait, getInDomain('playback.actions.shuffleSource')({ sourceId, enabled }));
}
